import { render } from "./DynamicBlogDetails.vue?vue&type=template&id=56ca89e2&scoped=true"
import script from "./DynamicBlogDetails.vue?vue&type=script&lang=js"
export * from "./DynamicBlogDetails.vue?vue&type=script&lang=js"

import "./DynamicBlogDetails.vue?vue&type=style&index=0&id=56ca89e2&scoped=true&lang=css"

import exportComponent from "/Users/frknalck/Desktop/MySite/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ca89e2"]])

export default __exports__